import { DianProvider, DocumentType } from '@shared-models';

import { ICountry } from 'src/app/@interfaces/country.interface';

import { CountryMapper } from './country.mapper';

export class ProviderMapper {
  static mapper(provider: DianProvider) {
    return {
      ...provider,
      types_docs: Array.isArray(provider.types_docs)
        ? (provider.types_docs[0] as DocumentType)
        : (provider.types_docs as DocumentType),
      country: CountryMapper.mapper(provider.country as ICountry),
      provider_type: provider.person_type,
    };
  }
}
